import React from 'react';
import { Table } from 'app-components';
import { resultColumns } from './StateBasedTableConfig';
import { ScreenType } from './types/apiResponse';

interface IMedicaidChipProps {
    data: any;
    screenType: ScreenType;
    handleShowMember?: any;
}
const MedicaidChipMembersTable = (medicaidChipTableProps: IMedicaidChipProps) => {
    const { data, screenType, handleShowMember } = medicaidChipTableProps;
    return (
        <div>
            <Table data={data} columns={resultColumns(screenType)} hasBorders onSelectRow={handleShowMember} />
        </div>
    );
};

export default MedicaidChipMembersTable;
